export default [
    {
        title: "Masters of Tradition.",
        overlay : "We like to know that our history, in one way or another, began 400 years ago. We enjoy working with a unique, artisanal and sophisticated product of which we are masters.",
        image: require("../../assets/images/aboutus/TUSA-MastersofTradition-tile-453x453.jpg"),
    },
    {
        title: "Creators and Innovators.",
        overlay : "We are passionate about innovating. It's in our DNA. Innovation in our business is the magical complement to tradition. Innovation for us is not risk, but the most sophisticated tool of common sense and the consequence of our deep knowledge of the business.",
        image: require("../../assets/images/aboutus/TUSA-CreatorsandInnovators-tile-453x453.jpg"),
    },
    {
        title: "Accountable Leaders.",
        overlay : "Leading the industry gives us an additional burden of responsibility. We are measured differently. We create trends. We open new paths for everyone in the demanding luxury sector.",
        image: require("../../assets/images/aboutus/TUSA-AccountableLeaders-tile-453x453.jpg"),
    },
    {
        title: "Multicultural.",
        overlay : "We interact with people from all over the world. We feel our work is written in a universal language and is part of a passion shared by people of all cultures and convictions.",
        image: require("../../assets/images/aboutus/TUSA-Multicultural-tile-453x453.jpg"),
    },
    {
        title: "Approachable People.",
        overlay : "We think that the extraordinary is born of normality. We are people who believe in work. Everyday people who use all their abilities generously. People who believe in work-life balance. Brilliant people? Yes. But normal people.",
        image: require("../../assets/images/aboutus/TUSA-ApproachablePeople-tile-453x453.jpg"),
    },
    {
        title: "Proud.",
        overlay : "We are proud of what we do. We are pleased to know that when we market our cigars, we are talking about culture, history, rituals, and lifestyles.",
        image: require("../../assets/images/aboutus/TUSA-Proud-tile-453x453.jpg"),
    },
];



// WEBPACK FOOTER //
// ./src/containers/AboutUs/AboutUsData.ts